let ProductFormValidation = new function(){
    let initCalled = false;
    let validationFunctions = [];
    let preAddBasketFunctions = [];
    executePreAddBasket=async ()=>{
        preAddBasketFunctions.forEach(async element => {
            await element();
        });        
    }

    executeValidations=()=>{
        let success = true;
        validationFunctions.forEach(element => {
            success = success && element();
            if(!success){
                return false;
            }
        });
        return success;
    }
    this.init = ()=>{
        if(this.initCalled){return;}
        this.initCalled = true;
        function waitForElm(selector) {
            return new Promise(resolve => {
              if (document.querySelector(selector)) {
                return resolve(document.querySelector(selector));
              }
              
              const observer = new MutationObserver(mutations => {
                if (document.querySelector(selector)) {
                  resolve(document.querySelector(selector));
                  observer.disconnect();
                }
              });
              
              
              observer.observe(document.body, {
                childList: true,
                subtree: true
              });
            });
          }

          waitForElm('form[data-type=add-to-cart-form] button[type=submit]').then(elem=>{
              elem.addEventListener('click', (e)=>{
                  e.preventDefault();
                  e.stopPropagation();
                  var executeResult = executeValidations();
                  if(!executeResult){
                      return;
                  }else{
                    executePreAddBasket().then(()=>{
                        setTimeout(()=>e.target.closest('form').dispatchEvent(new Event('submit')), 400);
                    });
                    return false;
                }
                });
        });
    }
    this.addValidation = (fn)=>{
        validationFunctions.push(fn);
    }

    this.addPreAddBasket = (fn)=>{
        preAddBasketFunctions.push(fn);
    }
    
}
ProductFormValidation.init();